import { Item } from '@app/modules/items';
import { ServiceItem } from '@app/modules/service-items/service-items.entity';
import { GameMode } from '@core/common';

import { User } from '../users';
import { Side } from '../event/battle.entity';

export interface MainBanner {
  id: number;
  title: string;
  subtitle: string;
  image: MainImage;
  context: BannerContext;
  urlType: UrlType;
  secretCode: string|null;
  offerEndsAt: string|null;
}

export interface BannerContext {
  newWindow?: boolean;
  url?: string;
}

export enum UrlType {
  INTERNAL = 1,
  EXTERNAL = 2,
  NONE = 3,
}

export interface MainImage {
  fileName: string;
}

export enum LiveDropType {
  GAME = 1,
  SERVICE_ITEM = 2,
}

export interface MainLiveDrop {
  id: number;
  user: User;
  type: LiveDropType;
  serviceItem: ServiceItem|null;
  amountUsd: string;
  mode: GameMode|null;
  isBigWin: boolean;
  item: Item|null;
  isAnimated?: boolean;
}

export type GameCard = {
  title: string;
  mode: GameMode;
  badge: string;
  routerLink: string|null;
  hideInMenu?: boolean;
  hideInMain?: boolean;
  isSoon?: boolean;
  isNew?: boolean;
  isHot?: boolean;
  disableAnimation?: boolean;
};

export namespace MainApiResponse {
  export interface Banners {
    banners: MainBanner[];
    tPoints: number;
    ctPoints: number;
    cardsCoins: number;
  }

  export interface LiveDrops {
    liveDrops: MainLiveDrop[];
  }

  export interface BattleState {
    ctSide: Side;
    tSide: Side;
  }
}
